import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, IconButton, Grid, Tooltip } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import ColorLegend from './ColorLegend';

import { DashboardLayerConfig } from 'types/types';

import 'assets/styles/MarkerTable.scss';

interface LayerCardProps {
  layerData: DashboardLayerConfig;
  mapZoomLevel: number;
  handleOnLayerClick: (layer: DashboardLayerConfig) => void;
}

const LayerCard: React.FC<LayerCardProps> = (
  {
    layerData,
    mapZoomLevel,
    handleOnLayerClick,
  }
) => {
  const layerOutOfZoom = layerData.MinZoomLevelSupported
    ? layerData.MinZoomLevelSupported > mapZoomLevel
    : false;

  return (
    <Box className="layer-card-container">
      {layerOutOfZoom ? (
        <Tooltip
          arrow
          title="Layer doesn't support current zoom level"
          placement="top"
        >
          <Box
            sx={{
              opacity: 0.5,
            }}
          >
            <Grid container spacing={0}>
              <Grid item>
                <IconButton size="small" className="visibility-button" disabled>
                  {layerData.selected ? (
                    <VisibilityOutlinedIcon />
                  ) : (
                    <VisibilityOffOutlinedIcon />
                  )}
                </IconButton>
              </Grid>

              <Grid item xs={10}>
                <Box className="layer-title">
                  <Grid container spacing={1}>
                    <Grid item>
                      {(layerData.LayerName )}
                    </Grid>
                    <Grid item>
                      {layerData.isLoading && (
                        <CircularProgress
                          size={'20px'}
                          sx={{ color: '#06345A' }}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <Box sx={{ ml: '-22px' }}>
                    {layerData.selected && (
                      <ColorLegend
                        legends={
                          layerData.LayerProperties?.LegendValueToColorMapping
                        }
                      />
                    )}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Tooltip>
      ) : (
        <Box>
          <Grid container spacing={0}>
            <Grid item>
              <IconButton
                size="small"
                className="visibility-button"
                onClick={() => {
                  handleOnLayerClick(layerData);
                }}
              >
                {layerData.selected ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </IconButton>
            </Grid>

            <Grid item xs={10}>
              <Box className="layer-title">
                <Grid container spacing={1}>
                  <Grid item>
                    {(layerData.LayerName)}
                  </Grid>
                  <Grid item>
                    {layerData.isLoading && (
                      <CircularProgress
                        size={'20px'}
                        sx={{ color: '#06345A' }}
                      />
                    )}
                  </Grid>
                </Grid>
                <Box sx={{ ml: '-22px' }}>
                  {layerData.selected && (
                    <ColorLegend
                      legends={layerData.LayerProperties?.LegendValueToColorMapping}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default LayerCard;
